import { words } from './lang';
import isMobilePhone from 'validator/lib/isMobilePhone';

export const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const validatePassword = (password) => {
  return password !== null && password.length > 5;
}

export const validatePhone = (phone) => {
  let phoneRegEx = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
  let phoneRegExWithSpace = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
  let regEx = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g;
  let regEx2 = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
  return phoneRegEx.test(phone) || phoneRegExWithSpace.test(phone) || regEx.test(phone) || regEx2.test(phone) || isMobilePhone(phone,"en-US") || isMobilePhone(phone,"en-US",[{strictMode: true}])
}

export const validateOfficeSetupPersonalDetails = (details) => {
  let errorFields = [];
  let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g

  
  if(details.firstName === undefined || details.firstName.trim() === '' || details.firstName.length === 0 || specialChar.test(details.firstName)) {
    errorFields.push('firstName');
  }
  if(details.lastName === undefined || details.lastName.trim() === '' || details.lastName.length === 0 || specialChar.test(details.lastName)) {
    errorFields.push('lastName');
  }
  // if(details.title === undefined || details.title.trim() === '' || details.title.length === 0) {
  //   errorFields.push('title');
  // }
  return errorFields;
}

export const validateOfficeSetupOfficeDetails = (details) => {
  const errorFields = [];
  if(details.officeFunction === null || details.officeFunction.length === 0) {
    errorFields.push('officeFunction');
  }
  if(details.address === undefined || details.address.length === 0) {
    errorFields.push('address')
  }
  return errorFields;
}

export const isValidExtension = (file,validExtensions) => {
  const fileName = file.name;
  var extDot = fileName.lastIndexOf(".") + 1;
  var extFile = fileName.substr(extDot, fileName.length).toLowerCase();
  if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
    // console.log("TRUE");
    return true;
  }else{
    // console.log("FALSE");
      return false;
  }
}

String.prototype.contains = function(str) { return this.indexOf(str) != -1; };

export const isProfane = (text) => {
  var returnVal = false; 
    for (var i = 0; i < words.length; i++) {
        if(text.toLowerCase().split(/\s+/).includes(words[i].toLowerCase())){
            returnVal = true;
            break;
        }
    }
  return returnVal;
}
// what is the best in class family leave policy in the manufacturing industry


 const logged_in_user_check = async (props, nextProps, ) => {

 

}